module.exports = __webpack_public_path__ + "static/media/SalesRevenue.60cbc559.svg";